import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { DataService } from 'src/app/services/data.service';
import * as moment from 'moment';

@Component({
  selector: 'app-thank-you',
  templateUrl: './thank-you.component.html',
  styleUrls: ['./thank-you.component.css']
})
export class ThankYouComponent implements OnInit, OnDestroy {

  /** Which page submitted the form — passed as ?source= query param */
  source: string = '';

  pageConfig: Record<string, { title: string; backUrl: string; label: string; logo: string; showCalendar?: boolean; pagetype?: string }> = {
    'wish-karo-sip-karo': {
      title: 'Wish Karo SIP Karo',
      backUrl: '/wish-karo-sip-karo',
      label: 'Back to Campaign',
      logo: '../../../assets/images/wish-sip/Wish-Karo-Sip-Karo-Landing-page1.webp'
    },
    'sip': {
      title: 'SIP Campaign',
      backUrl: '/sip',
      label: 'Back to Campaign',
      logo: ''
    },
    'khushiyonkiinvestment': {
      title: 'Khushiyon Ki Investment',
      backUrl: '/khushiyonkiinvestment',
      label: 'Back to Campaign',
      logo: '',
      showCalendar: true,
      pagetype: 'KhushiyonKiInvestment'
    },
    'talk-to-bajajcapital': {
      title: 'Talk to Bajaj Capital',
      backUrl: '/talk-to-bajajcapital',
      label: 'Back to Campaign',
      logo: ''
    },
    'talk-to-bcl': {
      title: 'Talk to Bajaj Capital',
      backUrl: '/talk-to-bcl',
      label: 'Back to Campaign',
      logo: ''
    },
    'new-priority': {
      title: 'New Priority',
      backUrl: '/new-priority',
      label: 'Back to Campaign',
      logo: ''
    }
  };

  currentConfig: any = this.pageConfig['wish-karo-sip-karo'];

  private gtmScriptEl: HTMLScriptElement | null = null;
  private gtmConfigEl: HTMLScriptElement | null = null;
  private gtmScript2El: HTMLScriptElement | null = null;
  private gtmNoscriptEl: HTMLElement | null = null;

  // Calendar and Time Slot Properties
  today = moment();
  currentMonth = moment();
  selectedDate: string = '';
  selectedCalendarDate: moment.Moment | null = null;
  selectedTimeSlot: string = '';
  appointmentDate: string = '';
  appointmentTime: string = '';
  isalreadyBooked: boolean = false;
  isCalendarPopupVisible: boolean = false;
  isButtonDisabled: boolean = false;
  popupmessage: string = '';
  isBlocked: boolean = false;

  timeSlots: string[] = [
    "10:00 AM - 11:00 AM",
    "11:00 AM - 12:00 PM",
    "12:00 PM - 01:00 PM",
    "01:00 PM - 02:00 PM",
    "02:00 PM - 03:00 PM",
    "03:00 PM - 04:00 PM",
    "04:00 PM - 05:00 PM",
    "05:00 PM - 06:00 PM",
    "06:00 PM - 07:00 PM"
  ];
  availableTimeSlots: string[] = [];
  calendarDays: any[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    @Inject(DOCUMENT) private document: Document,
    private service: DataService
  ) {}

  ngOnInit(): void {
    this.source = history.state?.source || '';
    this.currentConfig = this.pageConfig[this.source] || this.pageConfig['wish-karo-sip-karo'];

    this.isBlocked = history.state?.blocked || false;

    // Inject the page-specific GTM tag (AW-18261612633) only on this thank-you page
    this.injectGtag();
    this.injectGtmContainer();
    this.fireGoogleAdsConversion('AW-18261612633/Xc7fCMrSm9AcENmw6INE');

    if (this.currentConfig.showCalendar) {
      this.initializeCalendar();
      this.checkslot(this.isBlocked);
    }
  }

  ngOnDestroy(): void {
    // Clean up the injected scripts when navigating away
    if (this.gtmScriptEl) {
      this.document.head.removeChild(this.gtmScriptEl);
    }
    if (this.gtmConfigEl) {
      this.document.head.removeChild(this.gtmConfigEl);
    }
    if (this.gtmScript2El) {
      this.document.head.removeChild(this.gtmScript2El);
    }
    if (this.gtmNoscriptEl) {
      this.document.body.removeChild(this.gtmNoscriptEl);
    }
  }

  private fireGoogleAdsConversion(sendTo: string): void {
    const gtag = (window as any).gtag;
    if (typeof gtag === 'function') {
      gtag('event', 'conversion', { 'send_to': sendTo });
      return;
    }

    const dataLayer = (window as any).dataLayer = (window as any).dataLayer || [];
    dataLayer.push(['event', 'conversion', { 'send_to': sendTo }]);
  }

  private injectGtag(): void {
    // Script 1: Load the gtag.js library
    this.gtmScriptEl = this.document.createElement('script');
    this.gtmScriptEl.async = true;
    this.gtmScriptEl.src = 'https://www.googletagmanager.com/gtag/js?id=AW-18261612633';
    this.document.head.appendChild(this.gtmScriptEl);

    // Script 2: Initialize and configure
    this.gtmConfigEl = this.document.createElement('script');
    this.gtmConfigEl.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-18261612633');
    `;
    this.document.head.appendChild(this.gtmConfigEl);
  }

  private injectGtmContainer(): void {
    this.gtmScript2El = this.document.createElement('script');
    this.gtmScript2El.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-PSPS8S7B');
    `;
    this.document.head.appendChild(this.gtmScript2El);

    this.gtmNoscriptEl = this.document.createElement('noscript');
    const iframe = this.document.createElement('iframe');
    iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-PSPS8S7B';
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    this.gtmNoscriptEl.appendChild(iframe);
    if (this.document.body.firstChild) {
      this.document.body.insertBefore(this.gtmNoscriptEl, this.document.body.firstChild);
    } else {
      this.document.body.appendChild(this.gtmNoscriptEl);
    }
  }

  goBack(): void {
    this.router.navigateByUrl(this.currentConfig.backUrl);
  }

  // Calendar and Time Slot Methods
  initializeCalendar() {
    const availableDates = this.getNextAvailableDates();
    console.log('Next 3 available dates:', availableDates.map(date => ({
      date: date.format('YYYY-MM-DD'),
      day: date.format('dddd')
    })));

    this.generateCalendarDays();
  }

  generateCalendarDays() {
    const startOfMonth = this.currentMonth.clone().startOf('month');
    const endOfMonth = this.currentMonth.clone().endOf('month');
    const startDate = startOfMonth.clone().startOf('week');
    const endDate = endOfMonth.clone().endOf('week');

    this.calendarDays = [];
    const current = startDate.clone();

    while (current.isSameOrBefore(endDate, 'day')) {
      const dayObj = {
        date: current.clone(),
        isCurrentMonth: current.isSame(this.currentMonth, 'month'),
        isToday: current.isSame(this.today, 'day'),
        isSelected: this.selectedCalendarDate ? current.isSame(this.selectedCalendarDate, 'day') : false,
        isDisabled: this.isDateDisabled(current),
        isAvailable: this.isDateAvailable(current)
      };

      this.calendarDays.push(dayObj);
      current.add(1, 'day');
    }
  }

  isDateAvailable(date: moment.Moment): boolean {
    const availableDates = this.getNextAvailableDates();
    return availableDates.some(availableDate =>
      date.isSame(availableDate, 'day')
    );
  }

  getNextAvailableDates(): moment.Moment[] {
    const today = moment();
    const availableDates: moment.Moment[] = [];
    let currentDate = today.clone();
    let availableDaysCount = 0;

    while (availableDaysCount < 4) {
      if (currentDate.day() !== 0) { // Not Sunday
        if (currentDate.isSame(today, 'day')) {
          const todayTimeSlots = this.getAvailableTimeSlots(currentDate.format('YYYY-MM-DD'));
          if (todayTimeSlots.length > 0) {
            availableDates.push(currentDate.clone());
            availableDaysCount++;
          }
        } else {
          availableDates.push(currentDate.clone());
          availableDaysCount++;
        }
      }
      currentDate.add(1, 'day');
    }

    return availableDates;
  }

  selectCalendarDate(day: any) {
    if (day.isAvailable && !day.isDisabled && day.isCurrentMonth) {
      this.selectedCalendarDate = day.date;
      this.selectedDate = day.date.format('YYYY-MM-DD');
      this.selectedTimeSlot = ''; // Reset time slot when date changes
      this.availableTimeSlots = this.getAvailableTimeSlots(this.selectedDate); // Update available time slots
      this.generateCalendarDays(); // Refresh calendar to update selection
    }
  }

  previousMonth() {
    this.currentMonth.subtract(1, 'month');
    this.generateCalendarDays();
  }

  nextMonth() {
    this.currentMonth.add(1, 'month');
    this.generateCalendarDays();
  }

  clearSelection() {
    this.selectedCalendarDate = null;
    this.selectedDate = '';
    this.selectedTimeSlot = '';
    this.generateCalendarDays();
  }

  selectTimeSlot(timeSlot: string) {
    this.selectedTimeSlot = timeSlot;
  }

  getAvailableTimeSlots(selectedDate: string): string[] {
    const today = moment();
    const selectedMoment = moment(selectedDate);

    if (selectedMoment.isSame(today, 'day')) {
      const currentTime = moment();
      const currentHour = currentTime.hour();
      const currentMinute = currentTime.minute();

      return this.timeSlots.filter(timeSlot => {
        const startTimeStr = timeSlot.split(' - ')[0];
        const startTime = moment(startTimeStr, 'hh:mm A');
        const slotHour = startTime.hour();
        const slotMinute = startTime.minute();

        if (currentHour > slotHour || (currentHour === slotHour && currentMinute >= slotMinute)) {
          return false;
        }

        return true;
      });
    }

    return this.timeSlots;
  }

  isDateDisabled(date: moment.Moment): boolean {
    const today = moment();

    if (date.isBefore(today, 'day')) {
      return true;
    }

    const availableDates = this.getNextAvailableDates();
    const isAvailable = availableDates.some(availableDate =>
      date.isSame(availableDate, 'day')
    );

    return !isAvailable;
  }

  isAppointmentReady(): boolean {
    return !!(this.selectedDate && this.selectedTimeSlot);
  }

  checkslot(isBlocked: boolean = false) {
    const lsqId = sessionStorage.getItem('LSQ_id');
    const mobile = sessionStorage.getItem('mobile');
    const payload = {
      LSQ_id: lsqId,
      SlotDatetime: null,
      Mobile: mobile,
      pagetype: this.currentConfig.pagetype
    }
    this.service.updateSlotTime(payload).subscribe((res: any) => {
      console.log('CHECK SLOT RES $$$$', res);

      if (!res.success && res.message === 'DateSlot already booked for this page') {
        this.isalreadyBooked = true;
        const d = moment(res.SlotDatetime);
        this.appointmentDate = d.format("DD MMM YYYY");
        this.appointmentTime = d.format("hh:mm A");
      } else {
        this.isalreadyBooked = false;
        // Automatically open the popup on landing if no slot is booked
        if (!isBlocked) {
          this.openCalendarPopup();
        }
      }
    });
  }

  openCalendarPopup() {
    this.isCalendarPopupVisible = true;
  }

  closeCalendarPopup() {
    this.isCalendarPopupVisible = false;
  }

  confirmAppointment() {
    if (this.selectedDate && this.selectedTimeSlot) {
      const startTimeStr = this.selectedTimeSlot.split(' - ')[0];
      const slotMoment = moment(`${this.selectedDate} ${startTimeStr}`, 'YYYY-MM-DD hh:mm A');
      const slotDatetime = slotMoment.format('YYYY-MM-DD HH:mm:ss');

      const lsqId = sessionStorage.getItem('LSQ_id');
      const mobile = sessionStorage.getItem('mobile');

      if (lsqId) {
        const body = {
          LSQ_id: lsqId,
          SlotDatetime: slotDatetime,
          Mobile: mobile,
          pagetype: this.currentConfig.pagetype
        };

        this.isButtonDisabled = true;

        this.service.updateSlotTime(body).subscribe(
          (response: any) => {
            console.log('BOOKING RESPONSE $$$$', response);

            if (!response.success && response.message === 'DateSlot already booked for this page') {
              this.isalreadyBooked = true;
              const d = moment(response.SlotDatetime);
              this.appointmentDate = d.format("DD MMM YYYY");
              this.appointmentTime = d.format("hh:mm A");
              this.popupmessage = response.message;
              this.isButtonDisabled = true;
            } else {
              this.isalreadyBooked = true;
              const d = moment(slotDatetime);
              this.appointmentDate = d.format("DD MMM YYYY");
              this.appointmentTime = d.format("hh:mm A");
              this.popupmessage = '';
              this.isButtonDisabled = false;
              // Close popup after a short delay so user sees confirmation
              setTimeout(() => {
                this.closeCalendarPopup();
              }, 1500);
            }
          },
          (error: any) => {
            console.error('Error confirming appointment:', error);
            this.isButtonDisabled = false;
          }
        );
      }
    }
  }
}
